import {ActivityAreaResource} from '@/common/api/api-raw-types';
import {ActivityArea} from '../../../domain/experience/Experience';

export function toActivityArea(activityAreaKey: ActivityAreaResource): ActivityArea {
    return {
        id: activityAreaKey,
        translationKey: `company.activity.area.${activityAreaKey}`,
    };
}
